import {
  getLeoUuid,
  LeoUUID,
  getObject,
} from "@surya-digital/leo-ts-types";
import { Order, OrderDTO } from "../types/order";

export interface GroupChildQuestionOrderDTO {
  childQuestionId: string;
  order: OrderDTO;
}

export class GroupChildQuestionOrder {
  readonly isGroupChildQuestionOrderGroupChildQuestionOrder: boolean = true;

  readonly childQuestionId: LeoUUID;
  readonly order: Order;


  constructor(
  childQuestionId: LeoUUID, 
  order: Order
  ) {
    this.childQuestionId = childQuestionId;
    this.order = order;
  }

  static fromDTO(dto: GroupChildQuestionOrderDTO): GroupChildQuestionOrder {
    const childQuestionId = getLeoUuid(dto, "childQuestionId", InvalidGroupChildQuestionOrderChildQuestionIdError);
    const order = Order.fromDTO(getObject(dto, "order", InvalidGroupChildQuestionOrderOrderError));
    return new GroupChildQuestionOrder(
      childQuestionId,
      order
    );
  }

  toDTO(): GroupChildQuestionOrderDTO {
    const dto: GroupChildQuestionOrderDTO = {
        childQuestionId: this.childQuestionId.toDTO(),
        order: this.order.toDTO()
    };
    return dto;
  }
  }

GroupChildQuestionOrder.prototype.toString = function toString(): string {
  return `GroupChildQuestionOrder(childQuestionId='${this.childQuestionId}',order='${this.order}')`;
};

export class InvalidGroupChildQuestionOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildQuestionOrderError";
  }
}
export class InvalidGroupChildQuestionOrderChildQuestionIdError extends InvalidGroupChildQuestionOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildQuestionOrderChildQuestionIdError";
  }
}

export class InvalidGroupChildQuestionOrderOrderError extends InvalidGroupChildQuestionOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupChildQuestionOrderOrderError";
  }
}
